import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AccountAPIService } from '../account-api.service';
import { UserInfoService } from '../user-info.service';

/* InterestAPIService migrated from informAPI.js -v129 */
@Injectable({
	providedIn: 'root'
})
export class MyProfileService {
	PhotoChanged: any = null;
	CoverChanged: any = null;


	constructor(
		private userInfo: UserInfoService,
		private accountAPI: AccountAPIService
	) {
		this.PhotoChanged = new Rx.BehaviorSubject(1);
		this.CoverChanged = new Rx.BehaviorSubject(1);
	}

	setAvatar(isDefault:boolean, newData: any): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "Login is required");
		}
		else {
			if (isDefault) {
				return this.accountAPI.updateMyProfile({ Photo: { DefaultPhoto: newData } }).pipe(
					tap(() => { this.PhotoChanged.next(this.PhotoChanged.getValue() + 1); })
				);
			}
			else {
				return this.accountAPI.updateMyProfile({ Photo: { Base64Photo: newData } }).pipe(
					tap(() => { this.PhotoChanged.next(this.PhotoChanged.getValue() + 1); })
				);
			}
		}
	}

	setCover(isDefault: boolean, newData: any): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "Login is required");
		}
		else {
			if (isDefault) {
				return this.accountAPI.updateMyProfile({ CoverPhoto: { DefaultPhoto: newData } }).pipe(
					tap(() => { this.CoverChanged.next(this.CoverChanged.getValue() + 1); })
				);
			}
			else {
				return this.accountAPI.updateMyProfile({ CoverPhoto: { Base64Photo: newData } }).pipe(
					tap(() => { this.CoverChanged.next(this.CoverChanged.getValue() + 1); })
				);
			}
		}
	}

	getBio(): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "access deny");
		}
		else {
			return this.accountAPI.getMyProfile().pipe(map(
				response => {
					return response.Biography;
				}
			));
		}
	}

	setBio(newData: any): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "Login is required");
		}
		else {
			return this.accountAPI.updateMyProfile({Biography: newData });
		}
	}

	getRoleModels(): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "access deny");
		}
		else {
			return this.accountAPI.getMyProfile().pipe(map(
				response => {
					return response.RoleModel;
				}
			));
		}
	}

	setRoleModels(newData: any[]): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "Login is required");
		}
		else {
			return this.accountAPI.updateMyProfile({RoleModel: newData });
		}
	}

	// get current dream job
	getDreamJob(): Rx.Observable <any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "access deny");
		}
		else {
			return this.accountAPI.getMyProfile().pipe(map(
				response => {
					let currentDream = response.DreamJob.filter((x: any) => x.IsCurrent === true);
					if (currentDream !== null) {
						return currentDream[0];
					}
					else {
						return null;
					}
				}
			));
		}
	}

	// get all current dream jobs
	getDreamJobs(): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "access deny");
		}
		else {
			return this.accountAPI.getMyProfile().pipe(map(
				response => {
					return response.DreamJob;
				}
			));
		}
	}

	setDreamJobs(newData: any[]): Rx.Observable<any> {
		if (this.userInfo.isAnonymous()) {
			return Rx.throwError(() => "Login is required");
		}
		else {
			return this.accountAPI.updateMyProfile({DreamJob: newData});
		}
	}
}
